import { Tooltip, TooltipContent, TooltipTrigger } from 'cpool-components/general/Tooltip';
import type { LOAN_REQUEST_OFFER_SOURCE } from 'cpool-constants';
import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { HiOutlineDocumentCurrencyEuro } from 'react-icons/hi2';

import { useOfferById } from '../../../hooks/useOfferById';
import { CreditWorthinessButton } from '../CreditWorthinessButton';
import Spinner from '~/components/icons/Spinner';

type Props = {
    offerSource: LOAN_REQUEST_OFFER_SOURCE;
    offerId: string;
    aggregateId: string;
    routeControlled?: boolean;
    withLabel?: boolean;
};

export function HouseHoldCalculations({
    aggregateId,
    offerId,
    offerSource,
    routeControlled = false,
    withLabel = false,
}: Props) {
    const { t } = useTranslation();
    const { data, isPending } = useOfferById({ aggregateId, offerId });

    const content = (
        <div className="flex items-center gap-2 py-1.5 px-3">
            {isPending && offerSource === LOAN_REQUEST_OFFER_SOURCES.EUROPACE && (
                <Spinner className={'w-[16px] h-[16px] m-0'} />
            )}
            {!isPending &&
                (data?.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE ||
                    data?.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC) && (
                    <CreditWorthinessButton
                        {...data}
                        offerId={offerId}
                        routeControlled={routeControlled}
                        withLabel={withLabel}
                    />
                )}
            {(offerSource === LOAN_REQUEST_OFFER_SOURCES.CONSORS ||
                offerSource === LOAN_REQUEST_OFFER_SOURCES.MANUAL) && (
                <button
                    type="button"
                    disabled
                    className="flex items-center gap-2 w-full cursor-not-allowed disabled:opacity-50"
                >
                    <HiOutlineDocumentCurrencyEuro size={16} data-testid="house-hold-calculations-icon" />
                    {withLabel && (
                        <span className="text-xs px-3">{t('OFFER_MANAGEMENT.ICONS_TOOLTIP.HOUSEHOLD_BUDGET')}</span>
                    )}
                </button>
            )}
        </div>
    );

    if (withLabel) {
        return content;
    }

    return (
        <Tooltip>
            <TooltipTrigger>{content}</TooltipTrigger>
            <TooltipContent>{t('OFFER_MANAGEMENT.ICONS_TOOLTIP.HOUSEHOLD_BUDGET')}</TooltipContent>
        </Tooltip>
    );
}
